<script>
import { mapState, mapActions } from 'vuex'
export default {
  computed: mapState(['alert']),
  methods: {
    ...mapActions(['hideAlert'])
  },
  watch: {
    'alert.show'(val, old) {
      if (val && !old) {
        this.$snotify.warning(this.alert.msg, this.alert.title)
        this.hideAlert()
      }
    }
  }
}
</script>
